// Generic titled card wrapper used across settings-like pages.

import type { ReactNode } from 'react';

export function Section({
  title,
  hint,
  children,
}: {
  title?: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <div style={{ padding: '0 16px', marginBottom: 18 }}>
      {title && (
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: 'var(--text-3)',
            textTransform: 'uppercase',
            letterSpacing: 0.04,
            padding: '0 4px 8px',
          }}
        >
          {title}
        </div>
      )}
      <div className="lt-card" style={{ overflow: 'hidden' }}>
        {children}
      </div>
      {hint && (
        <div style={{ fontSize: 11, color: 'var(--text-3)', padding: '8px 4px 0' }}>{hint}</div>
      )}
    </div>
  );
}
